import { useEffect } from 'react'
import { AuthProvider, useAuth } from './state/auth'
import { ReposProvider } from './state/repos'
import { LoginScreen } from './ui/LoginScreen'
import { AppShell } from './ui/AppShell'

function Gate() {
  const { isUnlocked, dek, checked, refresh } = useAuth()
  useEffect(() => {
    refresh()
  }, [refresh])

  if (!checked) {
    return (
      <div className="login-screen">
        <p className="muted">Caricamento…</p>
      </div>
    )
  }

  if (!isUnlocked || !dek) {
    return <LoginScreen />
  }

  return (
    <ReposProvider dek={dek}>
      <AppShell />
    </ReposProvider>
  )
}

export function App() {
  return (
    <AuthProvider>
      <Gate />
    </AuthProvider>
  )
}
